export default __webpack_public_path__ + "static/media/872.aecd2f7b.png";